import { render, staticRenderFns } from "./TipoModalidadeList.vue?vue&type=template&id=6f562f8e"
import script from "./TipoModalidadeList.vue?vue&type=script&lang=js"
export * from "./TipoModalidadeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports